import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Button } from '@material-ui/core'
import { IconDefinition } from './models';

const styles = (theme: CentricTheme) => ({
  root:        {
    ...theme.styles.components.button,
    color: 'rgba(27, 27, 27, 0.54)'
  },
  leftIcon:    {
    marginRight: theme.spacing(),
    width:       theme.styles.components.icon.width,
    height:      theme.styles.components.icon.height
  },
  rightIcon:   {
    marginLeft: theme.spacing(),
    width:      theme.styles.components.icon.width,
    height:     theme.styles.components.icon.height
  },
  textPrimary: {
    '&:hover': {
      backgroundColor: 'rgba(27, 27, 27, 0.05)'
    }
  },
  buttonLabel: {
    marginTop: -1
  }
})

interface MyProps extends StyledProps {
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** Function to be called on Button Click */
  onClick: (e) => void,
  /** React component of an icon */
  icon?: IconDefinition

  disableFocusRipple?: boolean;
  disableRipple?: boolean;
  fullWidth?: boolean;
  href?: string;
  mini?: boolean;
  size?: 'small' | 'medium' | 'large';
  type?: 'submit' | 'reset' | 'button';
  variant?: 'text' | 'outlined' | 'contained' | 'raised' | 'fab' | 'extendedFab';
}

export class TertiaryButtonComponent extends React.Component<MyProps> {
  static defaultProps = {
    disabled: false,
    onClick:  () => {}
  }

  render() {
    const {classes, icon, children, ...otherProps} = this.props

    return (
      <Button
        classes={{root: classes.root, textPrimary: classes.textPrimary, label: classes[icon && icon.component ? 'buttonLabel' : '']}}
        {...otherProps}
        variant={'text'}
        color={'primary'}>
        {icon && icon.component && icon.position === 'left'
         ? <div className={classes.leftIcon}>{icon.component}</div>
         : null}
        {children}
        {icon && icon.component && icon.position === 'right'
         ? <div className={classes.rightIcon}>{icon.component}</div>
         : null}
      </Button>
    )
  }
}

@(withStyles as any)(styles)
export class TertiaryButton extends TertiaryButtonComponent{}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/TertiaryButton.tsx